import { useDispatch, useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { editModeOff, editModeOn, selectEditMode } from "../../slices/editMode/editModeSlice";
import { selectGlobalLoading } from "../../slices/globalLoading/globalLoadingSlice";
import { changesCleared, selectChangedResourcesList, selectChangedResourcesListStatus } from "../../slices/changedResourcesList/changedResourcesListSlice";
import { selectTabFocus } from "../../slices/tabPane/tabPaneSlice";
import { selectCurrentUserApiToken, selectCurrentUserId, selectCurrentUserName, selectSseConnectionId } from "../../slices/currentUser/currentUserSlice";
import { selectAllResources, selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import submitUpdatedResource from "../resourceDisplayCommonFunctions/submitUpdatedResource";
import { Checkbox } from "@mui/material";
import { useEffect, useState } from "react";
import { selectTrackingOn, trackingIsOn } from "../../slices/foiOfFocus/foiOfFocusSlice";
import getTrackedChanges from "../../functions/getTrackedChangesAPI";
import { updateTrackedChanges } from "../../functions/trackedChangesFunctions";
import updateTrackedChangesOnServer from "../../functions/updateTrackedChangesAPI";
import deleteEmptyElementsInObjectRecursive from "../../functions/deleteEmptyJsonElements";
import updateFhirJson from "../../functions/updateFhirJsonAPI";
import { triggerRefreshOn } from "../../slices/triggerRefresh/triggerRefreshSlice";
import { selectAllTrackedChanges, selectTrackChangesStatus } from "../../slices/trackChanges/trackChangesSlice";

const submitUpdatedResourceWithChangeTrackingChanges = async (dispatch, apiToken, foi,
    trackedChangesStatus, allTrackedChanges, oldResourceJson, newResourceJson,
    resourceCollection, changedResourcesList, connectionId, userName) => {
    let changes = {};
    if (trackedChangesStatus === "succeeded") {
        for (let item of allTrackedChanges) {
            changes[item.id] = JSON.parse(JSON.stringify(item));
        }
    } else {
        changes = await getTrackedChanges(foi, apiToken);
    }
    updateTrackedChanges(changes, oldResourceJson, newResourceJson, userName);
    let revisedChanges = JSON.parse(JSON.stringify(changes));
    await updateTrackedChangesOnServer(foi, revisedChanges, apiToken);
    console.log("---------saveAllChanges ---------------------------")
    const filteredResourceCollection = resourceCollection.filter(entry => (changedResourcesList.includes(entry.id) || foi === entry.id));
    let primaryEntryUpdated;
    for (const entry of filteredResourceCollection) {
        let entryFoi = entry.id;
        if (entryFoi === foi) {
            primaryEntryUpdated = entry;
        } else {
            let theResourceJson = JSON.parse(JSON.stringify(entry.revisedResourceJson));
            let title = entry.displayTitle;
            deleteEmptyElementsInObjectRecursive(theResourceJson);
            console.log("updating server for " + entryFoi)
            await updateFhirJson(entryFoi, theResourceJson, title, apiToken, connectionId,
                undefined, null, null, undefined, null
            );
        }
    }
    let theResourceJson;
    let title;
    if (primaryEntryUpdated && newResourceJson) {
        theResourceJson = newResourceJson;
        title = primaryEntryUpdated.displayTitle; //TODO -- change tracking and changing display title may not cooperate
        let trimmedResourceJson = deleteEmptyElementsInObjectRecursive(JSON.parse(JSON.stringify(theResourceJson)));
        let response = await updateFhirJson(foi, trimmedResourceJson, title, apiToken, connectionId,
            undefined, null, null, undefined, true);
        if (response?.success) {
            //if (addToast) {
            //    addToast('The resource has been updated.', { appearance: 'success' });
            //}
            dispatch(changesCleared());
            dispatch(editModeOff());
            dispatch(triggerRefreshOn());
        }
    } else {
        alert("The Resource was not updated.");
    }
}

const EditUpdateButton = ({ foi, jsonViewEditingState, setJsonViewEditingState, setParentResourceAlertModalState, addToast }) => {
    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const connectionId = useSelector(selectSseConnectionId);
    const userName = useSelector(selectCurrentUserName);
    const resourceCollection = useSelector(state => selectAllResources(state));
    const unsavedChanges = useSelector(state => selectChangedResourcesListStatus(state));
    const changedResourcesList = useSelector(state => selectChangedResourcesList(state));
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson || parentResourceDetail?.resourceJson;
    const siteIsLoading = useSelector(selectGlobalLoading);
    const userId = useSelector(selectCurrentUserId);
    const editPermission = parentResourceDetail?.permissionData?.editpermission;
    const apiToken = useSelector(selectCurrentUserApiToken);
    const tabFocus = useSelector(state => selectTabFocus(state));
    const editText = "Edit " + (resourceJson?.resourceType || "");
    const trackingOnStatus = useSelector(selectTrackingOn);
    const trackedChangesStatus = useSelector(selectTrackChangesStatus);
    const allTrackedChanges = useSelector(selectAllTrackedChanges);
    const oldResourceJson = parentResourceDetail?.resourceJson;
    const newResourceJson = parentResourceDetail?.revisedResourceJson;

    const [trackingOnState, setTrackingOnState] = useState(false);

    useEffect(() => {
        if (trackingOnStatus === true) {
            setTrackingOnState(true);
        }
    }, [trackingOnStatus]);

    return <div style={{
        width: "100%",
        margin: "0px"
    }}>
        <Button className="formButton navigationButton"
            style={{
                color: unsavedChanges !== "hasChanges" && "#000000",
                fontSize: unsavedChanges === "hasChanges" && "20px",
                width: "100%",
                margin: "0px"
            }}
            positive={unsavedChanges === "hasChanges"}
            content={((editMode || unsavedChanges === "hasChanges") ? "Save All Changes" : editText)}
            onClick={(event) => {
                //event.target.disabled = true; //Enable this and the one of the bottom if we ever have a problem with double clicking (again) OR if we don't want people to accidentally trigger it with their Enter key
                if (editMode || unsavedChanges === "hasChanges") {
                    if (editMode && trackingOnStatus === true && unsavedChanges === "hasChanges") {
                        submitUpdatedResourceWithChangeTrackingChanges(dispatch, apiToken, foi,
                            trackedChangesStatus, allTrackedChanges, oldResourceJson, newResourceJson,
                            resourceCollection, changedResourcesList, connectionId, userName)
                    } else {
                        submitUpdatedResource(foi, parentResourceDetail, apiToken, connectionId, dispatch,
                            resourceCollection, changedResourcesList, tabFocus, jsonViewEditingState,
                            setJsonViewEditingState, setParentResourceAlertModalState, addToast, trackingOnState);
                    }
                } else {
                    dispatch(editModeOn());
                }
                //event.target.disabled = false;
            }}
            disabled={(!siteIsLoading && userId && editPermission) ? false : true}
        />
        {editMode &&
            <p className="unselectable" style={{ textAlign: "left", fontSize: "14px" }} >
                <Checkbox style={{ padding: "0px", marginRight: "4px", cursor: "pointer" }}
                    checked={trackingOnState} size="small" color="primary"
                    onChange={() => {
                        setTrackingOnState(prevState => {
                            let checked = !prevState;
                            if (checked) {
                                dispatch(trackingIsOn());
                            }
                            return checked;
                        });
                    }} />
                <span>track changes</span>
            </p>
        }
    </div>;
};

export default EditUpdateButton;